/**
 * Enum representing generic backend error codes and their meanings
 */
export enum GenericErrorCode {
  /** You currently have an outstanding payment on your subscription */
  OutstandingPayment = 1,

  /** Your free subscription has expired */
  ExpiredFreeSubscription = 2,

  /** Customer is Premium, but no valid subscription found */
  NoValidSubscription = 3,

  /** Fair usage limit exceeded */
  FairUsageLimitExceeded = 4,

  /** Customer is Premium, but subscription is inactive */
  InactiveSubscription = 5,

  /** Customer is Premium, but subscription is paused */
  PausedSubscription = 6,

  /** Customer is Premium, but subscription payment could not be found */
  PaymentNotFound = 7,

  /** Your email is not verified */
  UnverifiedEmail = 8,

  /** Track is not live */
  TrackNotLive = 9,

  /** You've tried to download a Premium track with a free account */
  PremiumTrackWithFreeAccount = 10,

  /** You've used all your downloads */
  DownloadsExhausted = 11,

  /** Unknown exception error */
  UnknownError = 12,
}

/**
 * Enum representing recaptcha error codes and their meanings
 */
export enum RecaptchaErrorCode {
  /** reCAPTCHA response empty */
  Empty = 50,

  /** reCAPTCHA validation not successful */
  NotSuccessful = 51,

  /** reCAPTCHA v3 score too low */
  ScoreLow = 52,

  /** reCAPTCHA validation failed */
  Failed = 53,
}

export const BackendErrorCode = {
  ...GenericErrorCode,
  ...RecaptchaErrorCode,
};
